import { render, staticRenderFns } from "./bookinfo.vue?vue&type=template&id=4396c9d8&scoped=true"
import script from "./bookinfo.vue?vue&type=script&lang=js"
export * from "./bookinfo.vue?vue&type=script&lang=js"
import style0 from "./bookinfo.vue?vue&type=style&index=0&id=4396c9d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4396c9d8",
  null
  
)

export default component.exports